document.addEventListener('DOMContentLoaded', ()=>{
  document.querySelectorAll('.WRapperKyPoints__bnft').forEach( (evt)=>{
    evt.addEventListener('click', (elm)=>{
      elm.target.parentNode.closest('.WrapperMnBenifitsPoitsyup').classList.toggle('active');
    })
  })
  let Program$Slide = document.querySelector('.BlocksProgram__mainContainer');
  $(Program$Slide).slick({
    dots: false,arrows: false,infinite: true,slidesToShow: 4,responsive: [{breakpoint: 768,settings: {slidesToShow: 1}}]
  })
})
